import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../constants/colors';
import Translator from '../../../../components/helpers/Translator';

export const getState = (stateNumber) => {
  const state = {};

  switch (stateNumber) {
    default:
    case -1:
      state.icon = 'settings-2';
      state.bgColor = colors.bootstrapWarning;
      state.fgColor = '#000';
      state.title = ReactDOMServer.renderToString(
        <Translator file="module-resourceManager" name="resource.state-1" />
      );
      break;
    case 0:
      state.icon = 'file';
      state.bgColor = colors.unfulfilled;
      state.fgColor = '#000';
      state.title = ReactDOMServer.renderToString(
        <Translator file="user" name="user.obligations.state0" />
      );
      break;
    case 1:
      state.icon = 'check';
      state.bgColor = colors.success;
      state.fgColor = '#fff';
      state.title = ReactDOMServer.renderToString(
        <Translator file="user" name="user.obligations.state1" />
      );
      break;
    case 2:
      state.icon = 'settings-5';
      state.bgColor = colors.state2;
      state.fgColor = '#fff';
      state.title = ReactDOMServer.renderToString(
        <Translator file="user" name="user.obligations.state2" />
      );
      break;
    case 3:
      state.icon = 'alert';
      state.bgColor = colors.danger;
      state.fgColor = '#fff';
      state.title = ReactDOMServer.renderToString(
        <Translator file="user" name="user.obligations.state3" />
      );
      break;
    case 10:
      state.icon = 'hourglass';
      state.bgColor = colors.warning;
      state.fgColor = '#000';
      state.title = ReactDOMServer.renderToString(
        <Translator file="module-resourceManager" name="resource.ignorable" />
      );
      break;
  }

  return state;
};

export const getNextDateHuman = (nextDateSettings) => {
  let nextDateText = `${ReactDOMServer.renderToString(
    <Translator file="module-resourceManager" name="resource.every" />
  )} ${
    nextDateSettings.period > 1 ? `${nextDateSettings.period} ` : ''
  }`;
  switch (nextDateSettings?.periodType) {
    case 'days':
      nextDateText +=
        nextDateSettings.period > 1
          ? ReactDOMServer.renderToString(
              <Translator file="module-resourceManager" name="resource.days" />
            )
          : ReactDOMServer.renderToString(
              <Translator file="module-resourceManager" name="resource.day" />
            );
      break;
    case 'weeks':
      nextDateText +=
        nextDateSettings.period > 1
          ? ReactDOMServer.renderToString(
              <Translator file="module-resourceManager" name="resource.weeks" />
            )
          : ReactDOMServer.renderToString(
              <Translator file="module-resourceManager" name="resource.week" />
            );
      break;
    default:
    case 'months':
      nextDateText +=
        nextDateSettings.period > 1
          ? ReactDOMServer.renderToString(
              <Translator
                file="module-resourceManager"
                name="resource.months"
              />
            )
          : ReactDOMServer.renderToString(
              <Translator
                file="module-resourceManager"
                name="resource.month"
              />
            );
      break;
    case 'years':
      nextDateText +=
        nextDateSettings.period > 1
          ? ReactDOMServer.renderToString(
              <Translator file="module-resourceManager" name="resource.years" />
            )
          : ReactDOMServer.renderToString(
              <Translator file="module-resourceManager" name="resource.year" />
            );
      break;
  }

  return nextDateText;
};
